import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useToast } from "@chakra-ui/react";

import { useAuth } from "../auth/hooks";

const allowedAdmin: string[] = ["OWNER"];

export interface ITime {
  exp: number;
  iat: number;
}

function AdminProtectedRoute({ children }: any) {
  const { user } = useAuth();
  const userData = localStorage.getItem("user");
  const toast = useToast();

  const location = useLocation();

  if (!userData) {
    window.location.reload();
    return (window.location.href = "/admin/login");
  }
  const admin = user?.role ?? "";

  const decodedToken: ITime | null = user?.access_token
    ? jwtDecode(user?.access_token)
    : null;

  const isExpire = decodedToken && decodedToken?.exp * 1000 < Date.now();
  // const userData = localStorage.getItem("user");

  useEffect(() => {
    if (!userData) {
      console.log(" run");
      window.location.replace("/admin/login");
      history.replaceState("sessionExpired", "/admin/login");
      window.location.reload();
    }
  }, [userData]);

  useEffect(() => {
    if (!userData || (user?.access_token && isExpire)) {
      localStorage.removeItem("user");
      window.location.reload();
      window.location.href = "/admin/login";
      toast.closeAll();
      toast({
        title: "Error",
        description: "Your login session is expired. Login again",
        status: "error",
        isClosable: true,
        duration: 2000,
      });
    }
  }, [user?.access_token, decodedToken, isExpire]);

  if (!allowedAdmin?.includes(admin) || isExpire) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
}

export default AdminProtectedRoute;
